import { useState, useEffect } from 'react';
import { formatDateInput, parseDateText, formatDateToString } from './dateUtils';

/**
 * Composant d'input de date avec formatage automatique JJ/MM/AAAA
 * @param {object} props
 * @param {string} props.label - Le libellé du champ
 * @param {Date|null} props.value - La valeur Date
 * @param {function} props.onChange - Callback appelé avec la nouvelle Date
 * @param {string} props.placeholder - Placeholder (défaut: "JJ/MM/AAAA")
 * @param {string} props.className - Classes CSS additionnelles
 * @param {React.ReactNode} props.suggestion - Élément de suggestion optionnel
 */
const DateInput = ({ 
  label, 
  value, 
  onChange, 
  placeholder = "JJ/MM/AAAA",
  className = "",
  suggestion = null 
}) => {
  const [textValue, setTextValue] = useState('');

  // Synchroniser la valeur texte avec la valeur Date
  useEffect(() => {
    if (value instanceof Date && !isNaN(value)) {
      setTextValue(formatDateToString(value));
    } else if (!value) {
      setTextValue('');
    }
  }, [value]);

  const handleChange = (e) => {
    const formatted = formatDateInput(e.target.value);
    setTextValue(formatted);
    
    // Tenter de parser la date si le format est complet
    const parsedDate = parseDateText(formatted);
    onChange(parsedDate);
  };

  const handleBlur = (e) => {
    const parsedDate = parseDateText(e.target.value);
    if (parsedDate) {
      onChange(parsedDate);
      setTextValue(formatDateToString(parsedDate));
    } else if (e.target.value.length === 10) {
      // Format complet mais date invalide, réinitialiser
      setTextValue('');
      onChange(null);
    }
  };

  return (
    <div className={'w-full'}>
      <label className="ft-sm text-gray-500">
        <div>{label}</div>
        <div>
          <input
            type="text"
            placeholder={placeholder}
            maxLength={10}
            className={`w-full h-10 pl-3 pr-8 ft-b border rounded-lg text-center text-gray-900 ${className}`}
            value={textValue}
            onChange={handleChange}
            onBlur={handleBlur}
          />
        </div>
        {suggestion}
      </label>
    </div>
  );
};

export default DateInput;
